( function () {
	'use strict';

	function SelectOnFocus () {
		return {
			'restrict' : 'A',
			'link'     : function ( scope, element ) {
				element.on( 'focus', function () {
					this.select();

					element.bind( 'mouseup', function () {
						element.unbind( 'mouseup' );
						return false;
					} );
				} ).on( 'keyup', function ( e ) {
					if ( e.which === 9 ) {
						this.select();
					}
				} );
			}
		};
	}

	angular
		.module( 'app.components' )
		.directive( 'selectOnfocus', SelectOnFocus );
} )( );
